import React from "react";

import { classNames } from "repoV2/utils/common/render/classNames";
import { isTimePassed } from "@Utils";
import { IEvent } from "@Interfaces";

import { parseDateTime } from "@Utils/parseDateTime";
import styles from "./workshopSchedule.module.scss";
import useWorkshopSchedule from "./useWorkshopSchedule";
import ViewMore from "./components/ViewMore/ViewMore";

const WorkshopSchedule = () => {
    const {
        hideComponent,
        eventData,
        slotTitle,
        isExpanded,
        setExpanded,
        showMore,
        hideSessionTitle,
    } = useWorkshopSchedule();
    if (hideComponent) return null;

    return (
        <div className={styles.root}>
            {eventData?.slots
                ? eventData.slots
                      .slice(0, isExpanded ? eventData?.slots?.length : 5)
                      .map((slot: IEvent.ISlot) => (
                          <div
                              key={slot.uuid}
                              className={classNames(
                                  styles.workshopSlot,
                                  isTimePassed(
                                      parseDateTime(slot.start_time).valueOf()
                                  ) && styles.expiredSlot
                              )}
                              title={
                                  isTimePassed(
                                      parseDateTime(slot.start_time).valueOf()
                                  )
                                      ? "Class has already happened"
                                      : ""
                              }
                          >
                              <div className={styles.slotTitle}>
                                  {slotTitle(slot)}
                              </div>
                              <div className={styles.slotDuration}>
                                  {hideSessionTitle ? null : (
                                      <>
                                          {parseDateTime(
                                              slot.start_time,
                                              "E MMM dd yyyy"
                                          )}
                                          &nbsp;-&nbsp;
                                      </>
                                  )}
                                  {parseDateTime(slot.start_time, "HH:mm")}
                                  &nbsp;to&nbsp;
                                  {parseDateTime(slot.end_time, "HH:mm")}
                              </div>
                          </div>
                      ))
                : "No Slots"}
            {showMore ? (
                <ViewMore setExpanded={setExpanded} isExpanded={isExpanded} />
            ) : null}
        </div>
    );
};
export default WorkshopSchedule;
